


































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import StylePopup from './stylePopup.vue';

@Component({
  components: {
    StylePopup,
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class stepVideoStyle extends Vue {
  
  @Prop({ default: '' })
  title: string;
  @Prop({ default: false })
  isNewYear: boolean;
  @Prop({ default: '' })
  styleCode: string;

  styleList = []; // 视频风格列表
  currStyleItem = { // 当前选中的视频风格
    id: -1,
    nameEN: '',
  };
  currRatio = '9:16'; // 视频比例
  currEffect = '静态'; // 视频风格，静态/天气特效

  get pathSuffix() { return this.$publicPath + 'images/' + (this.isNewYear ? 'migu/newYear' : 'video_editor'); }

  // 获取最终提交参数
  get submitParams() {
    return {
      styleCode: this.currStyleItem.nameEN,
      scaleCode: this.currRatio,
      effectCode: this.currEffect,
    }
  }

  // 切换视频风格
  changeVideoStyle(item) {
    this.currStyleItem = item;
  }

  mounted() {
    this._getStylesFn();
  }

  @Watch('styleCode', { immediate: true })
  listenStyleCode(val) {
    if (val) {
      this.currStyleItem = {
        id: -1,
        nameEN: this.styleCode
      }
      this.setCurrStyleItem();
    }
  }

  // 获取视频风格列表
  _getStylesFn() {
    let vm = this;
    return this.$http('getStyleList', { pageSize: 9999 }).then(res => {
      if (res.code == 200) {
        const allStyles = (res.data && res.data.results) || [];
        vm.styleList = allStyles.filter(item => item.name != '日漫');
        vm.setCurrStyleItem();
      }
    });
  }

  setCurrStyleItem() {
    if(!this.styleList.length) return;
    const styleInfo = this.styleList.find(item => 
      item.id === this.currStyleItem.id || item.nameEN === this.currStyleItem.nameEN
    ) || this.styleList[0];
    this.currStyleItem = styleInfo;

    // 定位
    this.$nextTick(() => {
      const itemDom = document.getElementById(this.currStyleItem.nameEN + '_item');
      const rect = itemDom.getClientRects()[0];
      const listWrapper = this.$refs.styleListRef as any;
      listWrapper.scrollLeft += rect.left - 74
    });
  }

  // 全部弹窗
  isShowAllPopup = false;
  showAllPopup() {
    this.isShowAllPopup = true;
  }
  closeAllPopup() {
    this.isShowAllPopup = false;
    this.setCurrStyleItem();
  }
}
